import "./nachricht.css";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export default function Nachricht() {
  const { NewsId } = useParams();

  useEffect(() => {
    var formdata = new FormData();

    // console.log("NewsId", NewsId);
    formdata.append("id", NewsId);
    var myHeaders = new Headers();
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      credentials: "same-origin",
      headers: myHeaders,
      body: formdata,
    };

    fetch(
      "https://intranet-backend.procuratio.com/get_news.php",
      requestOptions
    )
      .then((response) => response.text())
      .then(
        (result) => {(document.getElementById("news_content").innerHTML = result); 
        // console.log("news", result) 
      }
      )
      .catch((error) => console.log("error", error));
  }, []);
  
  return (
    <div id="wrapper">
      <div>
        <div className="rounded_corner_right"></div>
        <div className="DA_info_container">
          <div id="news_content"></div>
        </div>
      </div>
    </div>
  );
}
